import { DocumentDesignEditor } from "./DocumentDesignEditor";

interface FooterZoneProps {
  value: string;
  onChange: (next: string) => void;
}

/**
 * "Footer" is the column name on the row, but the field renders into
 * the bottom-left margin running area of the page (alongside top-left,
 * top-right, and the page-1 header). It supports rich HTML.
 */
export function FooterZone({ value, onChange }: FooterZoneProps) {
  return (
    <DocumentDesignEditor
      value={value}
      onChange={onChange}
      height={240}
      uploadType="footer"
    />
  );
}
